import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/ribeiro/Development/dropdown-component-module/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/home/ribeiro/Development/dropdown-component-module/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a7fdf3b9c47fa471d0b0d01ee1c78ea.js')["default"];

export default Object.assign({}, scope_0, scope_1);